import { createAPI } from "./api/api";

const api = createAPI();

const accept = { "action": "accept" };
const reject = { "action": "reject" };

export const viewOffer = (id, setPopupHook) => {
  api.get(`/marketplace_offer/${id}`)
    .then((response) => setPopupHook({ type: 'offer', offerData: {...response.data, isCounter: false} }))
    .catch((error) => console.log(error));
};


export const viewCounterOffer = (id, setPopupHook) => {
  api.get(`/marketplace_counter_offer/${id}`)
  .then((response) => setPopupHook({ type: 'offer', offerData: {...response.data, isCounter: true} }))
  .catch((error) => {
    console.log('error of getting counter offer', error);
  });
}

export const declineOffer = (id, setStep, refreshItems) => {
  api.post(`/marketplace_offer/${id}/review_marketplace_offer`, reject)
    .then(() => {
      if (setStep) {
        setStep('success-decline')
      }
      refreshItems();
    })
    .catch((error) => {
      console.log('error of offer decline', error)
      if(setStep) {
        setStep('fail');
      }
    });
};

export const declineCounterOffer = (id, setStep, refreshItems) => {
  api.post(`/marketplace_counter_offer/${id}/review_marketplace_counter_offer`, reject)
  .then(() => {
    if (setStep) {
      setStep('success-decline')
    }

    refreshItems();
  })
  .catch((error) => {
    console.log('error of offer decline', error)
    if(setStep) {
      setStep('fail');
    }
  });
}

export const acceptOffer = (id, setStep, refreshItems, setIsLoading) => {
  setIsLoading(true)
  api.post(`/marketplace_offer/${id}/review_marketplace_offer`, accept)
  .then(() => {
    setIsLoading(false)
    setStep('success-accept');
    refreshItems();
  })
  .catch((error) => {
    console.log('error of accepting offer', error);
    setStep('fail')
  });
}

export const acceptCounterOffer = (id, setStep, refreshItems, setIsLoading) => {
  setIsLoading(true)
  api.post(`/marketplace_counter_offer/${id}/review_marketplace_counter_offer`, accept)
  .then(() => {
    if (setStep) {
      setIsLoading(false)
      setStep('success-accept');
      refreshItems();
    }
  })
  .catch((error) => {
    console.log('error of offer decline', error)
    if(setStep) {
      setStep('fail');
    }
  });
}

export const rejectCounterOffer = (id, setStep) => {
  api.post(`/marketplace_counter_offer/${id}/review_marketplace_counter_offer`, reject)
  .then(() => {
    if (setStep) {
      setStep('success-decline')
    }
  })
  .catch((error) => {
    console.log('error of offer decline', error)
    if(setStep) {
      setStep('fail');
    }
  });
}

export const makeCounterOffer = (id, amount, days, hours, setStep) => {
  const counterPayload = {
    marketplace_offer_id: id,
    amount: Number(amount),
    expires_in_days: Number(days),
    expires_in_hours: Number(hours)
  }

  api.post('/marketplace_counter_offer', counterPayload)
    .then(() => setStep('success-counter'))
    .catch((error) => {
      console.log('error of creating counter offer');
      setStep('fail')
    })
}

